<div provide-parent-form>

	<h3>{{ 'PROJECT' | translate }}<bb-info [contents]="'HELP.PROJECT_HEADER' | translate"></bb-info></h3>
	<!-- <h3><bb-form-element [form]="form" [helpMessage]="'HELP.PROJECT_HEADER' | translate"></bb-form-element>{{ 'PROJECT' | translate }}</h3> -->

	<bb-form-element [form]="form" invalidMessage="A project name is required" label="{{'NAME' | translate}}">
		<input [(ngModel)]="project.name" type="text" required name="project_name" />
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'GOAL' | translate}}" [helpMessage]="'HELP.PROJECT_GOAL' | translate">
		<textarea [(ngModel)]="project.goal" type="text" name="goal" maxlength="280">{{project.goal}}</textarea>
		<div *ngIf="project.goal"><small>
			{{ project.goal.length }} / 280 {{ 'CHARACTERS' | translate }}
		</small></div>
	</bb-form-element>
	
	<div [hasPermission]="'root'" class="root">
		<bb-form-element [form]="form" label="{{'START_CLIP' | translate}}">
			<bb-search-select disabled [(ngModel)]="project.mainMediaClipId" name="mainMediaClipId" [placeholder]="'SELECT_MEDIACLIP' | translate"></bb-search-select>
		</bb-form-element>

		<bb-form-element [form]="form" label="{{'SUBTYPE' | translate}}">
			<input [(ngModel)]="project.subtype" type="text" name="subtype" />
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'GAPLESS_PLAYBACK' | translate">
			<bb-check [(ngModel)]="project.useGaplessPlayback" [name]="'useGaplessPlayback'"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'USE_BUNDLED_METADATA' | translate">
			<bb-check [(ngModel)]="project.useGaplessMetadata" [name]="'useGaplessMetadata'"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PROJECT_WITHOUT_INTRO_CLIP' | translate">
			<bb-check [(ngModel)]="project.noIntroClip" [name]="'noIntroClip'"></bb-check>
		</bb-form-element>
		
		<bb-form-element [form]="form" [label]="'CONTEXTS' | translate">
			<bb-label-code-list [form]="form" [codeProp]="'code'" [(ngModel)]="project.contexts" name="contexts" (ngModelChange)="onContextOptionsChange()"></bb-label-code-list>
		</bb-form-element>
	</div>
	
	<bb-form-element [form]="form" label="{{'DISTRIBUTION' | translate}}" [helpMessage]="'HELP.PROJECT_DISTRIBUTION' | translate">
		<textarea autocomplete="none" [(ngModel)]="project.distribution" type="text" name="distribution">{{project.distribution}}</textarea>
	</bb-form-element>
	
	<bb-form-element [form]="form" label="{{'ANALYSIS' | translate}}" [helpMessage]="'HELP.PROJECT_ANALYSIS' | translate">
		<textarea [(ngModel)]="project.analysis" type="text" name="analysis">{{project.analysis}}</textarea>
	</bb-form-element>

	<h3>{{ 'PUBLIC_METADATA' | translate }}<bb-info [contents]="'HELP.PROJECT_METADATA' | translate"></bb-info></h3>
	<bb-form-element [form]="form" invalidMessage="The title is required" label="{{'TITLE' | translate}}">
		<input [(ngModel)]="project.title" type="text" name="title" />
	</bb-form-element>
	
	<bb-form-element [form]="form" label="{{'DESCRIPTION' | translate}}">
		<textarea [(ngModel)]="project.description" type="text" name="projectDescription">{{project.description}}</textarea>
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'AUTHOR' | translate}}">
		<input [(ngModel)]="project.author" type="text" name="author" />
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'COPYRIGHT' | translate}}">
		<input [(ngModel)]="project.copyright" type="text" name="copyright" />
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'DEEP_LINK' | translate}}"
		[helpMessage]="'HELP.PROJECT_DEEP_LINK' | translate"
		[actionButtonIcon]="'qrcode'"
		(actionButtonClick)="showQRCode()">
		<input [(ngModel)]="project.deeplink" type="text" name="deeplink" />
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'TAGS' | translate" [helpMessage]="'HELP.PROJECT_TAGS' | translate">
		<bb-entity-selector 
			[(ngModel)]="project.cat"
			name="project-tags"
			[entityType]="'project'"
			[extendable]="true"
			[multi]="true"
			[facet]="'cat'"
		></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element [form]="form" label="{{'TRANSCRIPT' | translate}}" [helpMessage]="'HELP.PROJECT_TRANSCRIPT' | translate">
		<textarea [(ngModel)]="project.transcript" type="text" name="projectTranscript">{{project.transcript}}</textarea>
	</bb-form-element>


	<p *ngIf="customFields" class="divider right-align"><small>{{ 'CUSTOM_FIELDS' | translate }}</small></p>

	<ng-container *ngFor="let field of customFields">
		<bb-form-element [form]="form" [label]="field.label" *ngIf="field.visible">
			<bb-field-renderer
				[(ngModel)]="project[field.name]"
				[fieldConfig]="field"
				[name]="'custom-' + field.name"
			></bb-field-renderer>
		</bb-form-element>
	</ng-container>
</div>

<ng-template #qrcodeModal>
	<bb-qrcode
		[entity]="project"
	></bb-qrcode>
</ng-template>
